import { render, staticRenderFns } from "./ClosureRemarksForm.vue?vue&type=template&id=6a0484c4"
import script from "./ClosureRemarksForm.vue?vue&type=script&lang=js"
export * from "./ClosureRemarksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports